import { WORKFLOW_AUTOMATION_ACTION_REGISTRY } from '../../workflow-automation-action.registry.js';

/**
 * `automation.action.<actionType>` — emitted by the workflow engine
 * (`emit-automation-action.js`) for every registered ACTION type.
 *
 * The action.type in the registry uses kebab-case (`render-report`, `start-workflow`).
 * We keep the **raw** event names here as catalog entries (no camelCase normalisation)
 * to preserve emit/subscribe parity. The naming audit script knows automation.action.*
 * is exempt from camelCase strict validation.
 */
const events = {};
for (const entry of WORKFLOW_AUTOMATION_ACTION_REGISTRY || []) {
    if (!entry?.eventName) continue;
    // Keys are full event names — registry/index will pick them up directly.
    events[entry.eventName] = {
        name: entry.eventName,
        entity: 'automation',
        verb: entry.actionType,
        subResource: 'action',
        lifecycle: false,
        scope: 'automation',
        transports: null,
        payload: null,
        description: `Automation action emitted for ${entry.actionType}`,
        deprecated: false,
        rawCase: true,
    };
}

export default {
    entity: 'automation',
    events,
};
